import React from 'react';
import classNames from 'classnames';

function Pagination({
  pageNumber,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
}) {
    
  const getStartIndex = () => {
    return totalCount === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
  };

  const getEndIndex = () => {
    const end = pageNumber * pageSize;
    return end > totalCount ? totalCount : end;
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (pageNumber <= 3) {
        for (let i = 2; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('ellipsis');
        pages.push(totalPages);
      } else if (pageNumber >= totalPages - 2) {
        pages.push('ellipsis');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push('ellipsis');
        for (let i = pageNumber - 1; i <= pageNumber + 1; i++) {
          pages.push(i);
        }
        pages.push('ellipsis');
        pages.push(totalPages);
      }
    }
    return pages;
  };
  if (totalCount === 0) return null;

  return (
    <div className="row mt-4 mb-3">
      <div className="col-md-6 d-flex align-items-center">
        <span className="text-muted">
          Showing {getStartIndex()} - {getEndIndex()} of {totalCount} results
        </span>
      </div>

      <div className="col-md-6">
        <div className="d-flex justify-content-end">
          <nav>
            <ul className="pagination pagination-rounded mb-0">
              {/* Previous */}
              <li className={classNames('page-item', { disabled: pageNumber === 1 })}>
                <button
                  className="page-link"
                  onClick={() => onPageChange(pageNumber - 1)}
                  disabled={pageNumber === 1}
                >
                  ‹
                </button>
              </li>

              {/* Page numbers */}
              {getPageNumbers().map((page, index) =>
                page === 'ellipsis' ? (
                  <li key={`ellipsis-${index}`} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li
                    key={page}
                    className={classNames('page-item', { active: page === pageNumber })}
                  >
                    <button
                      className="page-link"
                      onClick={() => onPageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                )
              )}

              {/* Next */}
              <li
                className={classNames('page-item', {
                  disabled: pageNumber === totalPages,
                })}
              >
                <button
                  className="page-link"
                  onClick={() => onPageChange(pageNumber + 1)}
                  disabled={pageNumber === totalPages}
                >
                  ›
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Pagination;
